app.component("medicationSection", {
	templateUrl: "app/src/js/components/injectionNote/medicationSection/medicationSection.html",
	controller: "medicationSectionController",
	bindings: {
		data: "<",
		eyeTitle: "@",
	},
});

app.controller("medicationSectionController", [
	"$scope",
	"INJECTIONPROCEDURE",
	"INJECTIONLOCATION",
	"DISTANCELIMBUS",
	"INTRAVITREAL_MEDICATION",
	"INTRAVITREAL_IMPLANT_MEDICATION",
	"SUBTENONS_INJECTION_MEDICATION",
	"ORBITAL_FLOOR_MEDICATION",
	"SUBCONJUNCTIVAL_INJECTION_MEDICATION",
	"INTRAVITREAL_TAP_INJECT_MEDICATION",
	function (
		$scope,
		INJECTIONPROCEDURE,
		INJECTIONLOCATION,
		DISTANCELIMBUS,
		INTRAVITREAL_MEDICATION,
		INTRAVITREAL_IMPLANT_MEDICATION,
		SUBTENONS_INJECTION_MEDICATION,
		ORBITAL_FLOOR_MEDICATION,
		SUBCONJUNCTIVAL_INJECTION_MEDICATION,
		INTRAVITREAL_TAP_INJECT_MEDICATION
	) {
		// The expiry is typed rather than picked, so a leading zero is optional on the way
		// in and the value is normalised back to DD/MM/YYYY once the field is left.
		const BATCH_EXPIRY_FORMAT = "DD/MM/YYYY";
		const BATCH_EXPIRY_INPUT_FORMATS = ["DD/MM/YYYY", "D/M/YYYY"];

		// Shared empty list so the option getters hand ng-options the same reference
		// every digest — a fresh [] each time makes the collection watch churn.
		const NO_OPTIONS = [];

		const MEDICATIONS_BY_PROCEDURE = {
			INTRAVITREAL_INJECTION: INTRAVITREAL_MEDICATION,
			INTRAVITREAL_IMPLANT: INTRAVITREAL_IMPLANT_MEDICATION,
			SUBTENONS_INJECTION: SUBTENONS_INJECTION_MEDICATION,
			ORBITAL_FLOOR_INJECTION: ORBITAL_FLOOR_MEDICATION,
			SUBCONJUNCTIVAL_INJECTION: SUBCONJUNCTIVAL_INJECTION_MEDICATION,
			INTRAVITREAL_TAP_AND_INJECT: INTRAVITREAL_TAP_INJECT_MEDICATION,
		};

		const DOSES_BY_PROCEDURE = {
			INTRAVITREAL_INJECTION: {
				BEVACIZUMAB: ["1.25mg/0.05mL"],
				AFLIBERCEPT: ["2mg/0.05mL"],
				FARICIMAB_SVOA: ["6mg/0.05mL"],
				RANABIZUMAB: ["0.5mg/0.05mL", "0.3mg/0.05mL"],
				TRIAMCINOLONE_ACETONIDE: ["4mg/0.1mL", "2mg/0.05mL"],
				METHOTREXATE: ["400mcg/0.1mL"],
				ZALTRAP: ["1.25mg/0.05mL"],
			},
			INTRAVITREAL_IMPLANT: {
				DEXAMETHASONE_IMPLANT: ["0.7mg"],
			},
			SUBTENONS_INJECTION: {
				TRIAMCINOLONE_ACETONIDE: ["40mg/1mL", "20mg/0.5mL"],
			},
			ORBITAL_FLOOR_INJECTION: {
				TRIAMCINOLONE_ACETONIDE: ["40mg/1mL", "20mg/0.5mL"],
			},
			SUBCONJUNCTIVAL_INJECTION: {
				DEXAMETHASONE: ["4mg", "8mg"],
				BEVACIZUMAB: ["2.5mg/0.1mL"],
				TRIAMCINOLONE_ACETONIDE: ["2mg", "4mg", "6mg", "8mg"],
			},
			INTRAVITREAL_TAP_AND_INJECT: {
				VITREOUS_TAP: ["0.05mL", "0.1ml", "0.15ml", "0.2ml", "0.25ml", "0.3ml"],
				CEFAZOLIN: ["2.25mg/0.1mL"],
				VANCOMYCIN: ["1mg/0.1mL"],
				AMIKACIN: ["400mcg/0.1mL"],
				CEFTAZIDIME: ["2mg/0.1mL"],
			},
		};

		$scope.injectionProcedure = INJECTIONPROCEDURE;
		$scope.injection_location = INJECTIONLOCATION;
		$scope.distance_from_limbus = DISTANCELIMBUS;

		// Sub-Tenon's and orbital floor triamcinolone is not measured from the limbus,
		// and the orbital floor has no injection location to record.
		function isDistanceHidden(item) {
			return (
				!!item &&
				item.medication === "TRIAMCINOLONE_ACETONIDE" &&
				(item.procedure_type === "SUBTENONS_INJECTION" || item.procedure_type === "ORBITAL_FLOOR_INJECTION")
			);
		}

		function isLocationHidden(item) {
			return !!item && item.medication === "TRIAMCINOLONE_ACETONIDE" && item.procedure_type === "ORBITAL_FLOOR_INJECTION";
		}

		$scope.showDistance = function (item) {
			return !isDistanceHidden(item);
		};

		$scope.showLocation = function (item) {
			return !isLocationHidden(item);
		};

		$scope.getMedicationOptions = function (item) {
			return (item && MEDICATIONS_BY_PROCEDURE[item.procedure_type]) || NO_OPTIONS;
		};

		$scope.getDoseOptions = function (item, search) {
			const doses = (item && (DOSES_BY_PROCEDURE[item.procedure_type] || {})[item.medication]) || NO_OPTIONS;
			const options = doses.slice();
			if (search && options.indexOf(search) === -1) {
				options.unshift(search);
			}
			return options;
		};

		$scope.onProcedureChange = function (item) {
			item.medication = null;
			item.dose = null;
			item.injection_location = null;
			item.distance_from_limbus = null;

			// Most procedures carry a single medication, so select it rather than making
			// the user pick from a list of one.
			const medications = $scope.getMedicationOptions(item);
			if (medications.length === 1) {
				item.medication = medications[0].id;
				$scope.onMedicationChange(item);
			}
		};

		$scope.onMedicationChange = function (item) {
			item.dose = null;
			if (isDistanceHidden(item)) {
				item.distance_from_limbus = null;
			}
			if (isLocationHidden(item)) {
				item.injection_location = null;
			}
		};

		$scope.addInjection = function () {
			$scope.$ctrl.data.injection_details.push({});
		};

		$scope.removeInjection = function (index) {
			$scope.$ctrl.data.injection_details.splice(index, 1);
			if ($scope.$ctrl.data.injection_details.length === 0) {
				$scope.$ctrl.data.injection_details.push({});
			}
		};

		// A blank trailing injection is normal — the section always shows one. Only a
		// half-filled one is worth flagging, and injectionNoteController drops the blanks
		// before the note is submitted.
		$scope.isInjectionStarted = function (item) {
			return !!(
				item &&
				(item.procedure_type ||
					item.medication ||
					item.dose ||
					item.injection_location ||
					item.distance_from_limbus ||
					item.batch_number ||
					item._batch_expiry_date)
			);
		};

		$scope.isInjectionIncomplete = function (item) {
			if (!$scope.isInjectionStarted(item)) {
				return false;
			}
			return !(
				item.procedure_type &&
				item.medication &&
				item.dose &&
				(isLocationHidden(item) || item.injection_location) &&
				(isDistanceHidden(item) || item.distance_from_limbus)
			);
		};

		// Each injection carries its own drug batch. The expiry is typed as dd/MM/yyyy
		// into the UI-only _batch_expiry_date and converted to a UTC instant on
		// batch_expiry_date_utc, which is the only half the backend stores.
		$scope.onBatchExpiryDateChange = function (item) {
			const parsed = parseBatchExpiryDate(item);
			item.batch_expiry_date_utc = parsed ? parsed.toISOString() : null;
		};

		$scope.onBatchExpiryDateBlur = function (item) {
			const parsed = parseBatchExpiryDate(item);
			if (parsed) {
				item._batch_expiry_date = parsed.format(BATCH_EXPIRY_FORMAT);
			}
		};

		function parseBatchExpiryDate(item) {
			const parsed = moment(item._batch_expiry_date, BATCH_EXPIRY_INPUT_FORMATS, true);
			return parsed.isValid() ? parsed : null;
		}

		$scope.onBatchNumberChange = function (item) {
			if (!item.batch_number) {
				item.batch_number = null;
			}
		};

		// ng-pattern takes anything with a test(), so the field's validity is the same
		// strict parse the stored UTC value comes from — a shape-only regex would let
		// 31/02/2027 through as a batch number with no expiry behind it.
		$scope.batchExpiryPattern = {
			test: function (value) {
				return !value || moment(value, BATCH_EXPIRY_INPUT_FORMATS, true).isValid();
			},
		};

		$scope.isBatchExpiryInvalid = function (item) {
			return !!item._batch_expiry_date && !parseBatchExpiryDate(item);
		};

		// The batch is optional, but a batch number and an expiry date go together.
		$scope.isBatchPairIncomplete = function (item) {
			return !!item.batch_number !== !!item.batch_expiry_date_utc;
		};

		// The note is rebuilt whenever a patient's saved injection settings load, so keep
		// one editable injection on screen and seed the display string for any expiry
		// date that arrives already set.
		$scope.$watchCollection("$ctrl.data.injection_details", function (items) {
			if (!$scope.$ctrl || !$scope.$ctrl.data) {
				return;
			}
			if (!angular.isArray(items)) {
				$scope.$ctrl.data.injection_details = [];
				items = $scope.$ctrl.data.injection_details;
			}
			if (items.length === 0) {
				items.push({});
			}
			items.forEach(function (item) {
				if (item.batch_expiry_date_utc && !item._batch_expiry_date) {
					item._batch_expiry_date = moment(item.batch_expiry_date_utc).format(BATCH_EXPIRY_FORMAT);
				}
			});
		});
	},
]);
